// extracted by mini-css-extract-plugin
export var isActiveStyle = "toc_link-module--isActiveStyle--RG9Sx";
export var linkWrapperStyle = "toc_link-module--linkWrapperStyle--TTmT6";
export var textStyle = "toc_link-module--textStyle--1L7Ei";